import './sell.scss'
import { useEffect, useMemo, useState, useCallback } from 'react'
import CommonModal from '@/components/CommonModal/CommonModal'
import { useStore } from '@/store'
import { useLocal } from '@/i18n/LocalContext'
import { useMaxWidth } from '@/hooks/useMaxWidth'
import CodeInput from '@/components/CodeInput/CodeInput'
import { $alert, toast } from '@/utils'
import { createPlayerName, getColorStyle } from '@app/utils'
import MarketBtn from '../MarketBtn/MarketBtn'
import { useSell } from '@app/hooks/useSell'
import useSellData from '@app/hooks/useSellData'
import Tooltips from '@/components/Tooltips/Tooltips'

export default function Sell() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const { sell } = useSell()
  const sellModalOpen = state.sellModalOpen
  const specifiedSellData = state.specifiedSellData
  const sellItem = useMemo(() => {
    if (!specifiedSellData.list.length) return null

    return specifiedSellData.list[0]
  }, [specifiedSellData])
  const playerName = useMemo(() => {
    if (!sellItem) return ''

    return createPlayerName(sellItem)
  }, [sellItem])
  const { safeAreaTop } = useMaxWidth()
  const coinStyle = useMemo(() => {
    const style = { transform: `translateY(${safeAreaTop}px)` }
    return style
  }, [safeAreaTop])
  const targetPlayerId = state.targetPlayerId
  const setTargetPlayerId = useCallback((val: string) => {
    dispatch({ type: 'setState', data: { targetPlayerId: val } })
  }, [])
  const { pending, fetchSellData } = useSellData()
  const [cd, setCD] = useState(false)
  const disabledStyle = useMemo(
    () => (cd ? { filter: 'grayscale(80%)' } : {}),
    [cd]
  )
  /** CD 5秒 */
  const cdTotal = 5
  const [cdTimeout, setCDTimeout] = useState(5)

  const search = useCallback(() => {
    if (cd) {
      toast($t('搜索太过频繁，请稍后'), true)
      return
    }

    if (!targetPlayerId) {
      $alert($t('请输入正确玩家UID'))
      return
    }

    setCD(true)
    fetchSellData()
  }, [cd, targetPlayerId, fetchSellData])
  useEffect(() => {
    if (!cd) return

    console.log('開始冷卻...')
    let n = 0
    const timer = window.setInterval(() => {
      n += 1
      if (n === cdTotal + 1) {
        setCD(false)
        console.log('冷卻結束')
        n = 0
        window.clearInterval(timer)
      }
      setCDTimeout(cdTotal - n)
    }, 1000)
  }, [cd])

  const onClose = useCallback(() => {
    dispatch({ type: 'setState', data: { sellModalOpen: false } })
  }, [])

  const handleSell = useCallback(() => {
    sell('search', specifiedSellData)
  }, [specifiedSellData, sell])

  return (
    <CommonModal
      open={sellModalOpen}
      onClose={onClose}
      title={$t('指定出售')}
      type="sell"
    >
      {[
        <div key="1" className="sell">
          <div className="sell-search-block">
            <CodeInput
              value={targetPlayerId}
              readOnly={pending}
              onChange={setTargetPlayerId}
            />
            <a
              className="sell-search-btn"
              style={disabledStyle}
              onClick={search}
            ></a>
          </div>
          <p className="sell-search-hints">
            {$t('*输入UID可前往其他玩家圣诞集市进行售卖')}
          </p>
          <div className="sell-search-cutline"></div>
          {sellItem ? (
            <div className="sell-search-result">
              <div className="sell-search-name">
                <span>{playerName}</span>
                <span>{playerName}</span>
              </div>
              <div className="sell-search-tree">
                <p className="sell-search-price">
                  {$t('今日收购价：')}
                  <span
                    className="sell-search-price__coin"
                    style={getColorStyle(sellItem)}
                  >
                    {sellItem.price}
                  </span>
                </p>
              </div>
              <MarketBtn type={2} onClick={handleSell}>
                {$t('出售')}
              </MarketBtn>
              <div className="christmas-modal-hints">
                {$t('剩余收购数量')}: {sellItem.overage}/{sellItem.total}
              </div>
            </div>
          ) : !pending ? (
            <div className="christmas-modal-hints">{$t('您还未进行搜索')}</div>
          ) : null}
          {pending ? (
            <div key="11" className="__onemt__loader-box">
              <div className="__onemt__loader"></div>
            </div>
          ) : null}
        </div>,
        <div key="2" className="coin-block" style={coinStyle}>
          <Tooltips
            title={$t('圣诞树')}
            content={$t('圣诞集市活动道具，可在圣诞集市活动中进行售卖')}
            place="right-start"
            ckey="sellcointree123"
            className="coin tree"
          >
            <span>{specifiedSellData.tree}</span>
          </Tooltips>
        </div>,
      ]}
    </CommonModal>
  )
}
